// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const CloseIcon = (props: IconProps) => (
  <Icon viewBox="0 0 48 48" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.9998 8.45005C15.4088 8.45005 8.4498 15.409 8.4498 24.0001C8.4498 32.5911 15.4088 39.55 23.9998 39.55C32.5908 39.55 39.5498 32.5911 39.5498 24.0001C39.5498 15.409 32.5908 8.45005 23.9998 8.45005ZM7.0498 24.0001C7.0498 14.6358 14.6356 7.05005 23.9998 7.05005C33.364 7.05005 40.9498 14.6358 40.9498 24.0001C40.9498 33.3643 33.364 40.95 23.9998 40.95C14.6356 40.95 7.0498 33.3643 7.0498 24.0001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0048 18.0053C18.2782 17.732 18.7214 17.732 18.9948 18.0053L29.9948 29.0053C30.2681 29.2787 30.2681 29.7219 29.9948 29.9953C29.7214 30.2686 29.2782 30.2686 29.0048 29.9953L18.0048 18.9953C17.7315 18.7219 17.7315 18.2787 18.0048 18.0053Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.9948 18.0053C30.2681 18.2787 30.2681 18.7219 29.9948 18.9953L18.9948 29.9953C18.7214 30.2686 18.2782 30.2686 18.0048 29.9953C17.7315 29.7219 17.7315 29.2787 18.0048 29.0053L29.0048 18.0053C29.2782 17.732 29.7214 17.732 29.9948 18.0053Z"
      fill="currentColor"
    />
  </Icon>
);
